import * as Hooks from './hooks';
import * as Utils from './utils';

export type * as InboxLocationPhonesTypes from './types';

export const InboxLocationPhones = { Hooks, Utils };
